import { showError } from '#imports';

const PUBLIC_STATUS = new Set([400, 403, 404, 409, 422, 429]);

function readStatus(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const rec = error as {
    status?: unknown;
    statusCode?: unknown;
    cause?: unknown;
  };
  if (
    Number.isInteger(rec.status) &&
    Number(rec.status) >= 400 &&
    Number(rec.status) < 600
  ) {
    return Number(rec.status);
  }
  if (
    Number.isInteger(rec.statusCode) &&
    Number(rec.statusCode) >= 400 &&
    Number(rec.statusCode) < 600
  ) {
    return Number(rec.statusCode);
  }
  if (rec.cause) {
    return readStatus(rec.cause);
  }
  return undefined;
}

export function isUnauthorizedError(error: unknown): boolean {
  return readStatus(error) === 401;
}

export function presentPageLoadError(error: unknown): void {
  if (isUnauthorizedError(error)) {
    return;
  }
  const statusCode = readStatus(error) ?? 500;
  const allowPublicMessage = PUBLIC_STATUS.has(statusCode);
  const message =
    allowPublicMessage && error instanceof Error && error.message.trim()
      ? error.message
      : 'pages.errors.unexpected';
  showError({
    statusCode,
    statusMessage: message,
    message,
    fatal: true,
  });
}
